import type { Prototype } from "../prototype-types";

export const samanthaYeePrototypes: Prototype[] = [
  {
    id: "sy-faire-source-atc-modal-ctas",
    name: "Faire Source ATC Modal CTAs",
    path: "/sy/faire-source-atc-modal-ctas",
    description:
      "Explores alternative CTA buttons on the Faire Source add-to-cart mini-shop modal shown from the PDP",
    owner: "Samantha Yee",
    createdAt: "2026-07-23",
    lastUpdated: "2026-07-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1e406b573bf8b35b97fd5a5e5e3f8cd0c785120ca1d2ffd8e7930487221d907c.png",
    creationTool: "claude-code",
  },
  {
    id: "sy-faire-source-cart-sidebar",
    name: "Faire Source Cart Sidebar",
    path: "/sy/faire-source-cart-sidebar",
    description:
      "Production-faithful cart page replica for exploring visual differentiation of Faire Source carts in the left sidebar.",
    owner: "Samantha Yee",
    createdAt: "2026-08-13",
    lastUpdated: "2026-08-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/78ac115122a0479817a787e13e976a791be6dd40c44d2b1ba9c505319c80e4d3.png",
    creationTool: "cursor",
    project: "Faire Source Cart",
  },
];
